export const SIGNUP_DATA_CONST = 'SIGNUP_DATA_CONST'

export const SET_AUTH_FLAG = 'SET_AUTH_FLAG'

export const USER_PROFILE_DATA = 'USER_PROFILE_DATA'